import React, { FunctionComponent } from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import { Typography, Grid, Paper, Divider } from "@material-ui/core";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
    },
    paper: {
      padding: theme.spacing(2),
      textAlign: "center",
      color: theme.palette.text.secondary,
    },
    itemDetailsTypography: {
      fontSize: "0.875rem",
      fontWeight: "bold",
      color: "black",
    },
  })
);

type WithBillDetailsProps = {
  itemDetails: Array<object>;
  invalidBillNumber: boolean;
};
export const WithBillDetails: FunctionComponent<WithBillDetailsProps> = ({
  itemDetails,
  invalidBillNumber,
}) => {
  const classes = useStyles();
  return (
    <Paper
      className={classes.paper}
      elevation={4}
      style={{ minHeight: "25em" }}
    >
      {invalidBillNumber ? (
        <Typography className={classes.itemDetailsTypography}>
          No Data
        </Typography>
      ) : (
        <Grid container spacing={2}>
          <Grid container>
            {itemDetails &&
              itemDetails.map((item: any) => (
                <Grid item xs={12}>
                  <Grid
                    container
                    spacing={1}
                    direction="row"
                    justify="flex-start"
                    alignItems="flex-start"
                  >
                    <Grid item xs={6} style={{ textAlign: "left" }}>
                      <Typography className={classes.itemDetailsTypography}>
                        {" "}
                        {item.ref_plu}
                      </Typography>
                    </Grid>
                    <Grid item xs={2} style={{ textAlign: "left" }}>
                      <Typography className={classes.itemDetailsTypography}>
                        {item.total_quantity > 1
                          ? `x ${item.total_quantity}`
                          : item.total_quantity}
                      </Typography>
                    </Grid>
                    <Grid item xs={4} style={{ textAlign: "left" }}>
                      <Typography className={classes.itemDetailsTypography}>
                        QR {item.item_price}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} style={{ textAlign: "left" }}>
                      <Typography className={classes.itemDetailsTypography}>
                        {item.item_name}
                      </Typography>
                    </Grid>
                    {/* <Grid item xs={3}>
                    <Typography className={classes.itemDetailsTypography}>
                      QR {item.total_item_price}
                    </Typography>
                  </Grid> */}
                  </Grid>
                  {itemDetails.length > 1 ? (
                    <Divider style={{ backgroundColor: "#2978ca" }} />
                  ) : (
                    ""
                  )}
                </Grid>
              ))}
          </Grid>
        </Grid>
      )}
    </Paper>
  );
};
